import React, { useEffect } from 'react';

import ComponentType from '../../../types/Component';

import { CoordsType } from './index';
import styles from './styles.module.scss';

type PortalType = {
	coords: CoordsType;
	updateTooltipCoords: () => void;
	nodeSelectorToTrack?: string;
};

const TooltipPopover: ComponentType<PortalType> = ({
	children,
	coords,
	updateTooltipCoords,
	nodeSelectorToTrack,
}) => {
	useEffect(() => {
		const tracker = nodeSelectorToTrack
			? document.querySelector(nodeSelectorToTrack) ?? window
			: window;
		tracker?.addEventListener('scroll', updateTooltipCoords);
		window?.addEventListener('resize', updateTooltipCoords);

		return () => {
			tracker?.removeEventListener('scroll', updateTooltipCoords);
			tracker?.removeEventListener('resize', updateTooltipCoords);
		};
	}, [updateTooltipCoords]);

	return (
		<div style={{ ...coords }} role="tooltip" className={styles.TooltipPopover}>
			{children}
		</div>
	);
};

export default TooltipPopover;
